import { useState } from 'react';
import apiClient from '../utils/api';

interface LoginCredentials {
  email: string;
  password: string;
}

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const login = async (credentials: LoginCredentials): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post('/users/login', credentials);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('email', response.data.email);
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Login failed. Please try again.';
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
  };

  const isAuthenticated = (): boolean => {
    return !!localStorage.getItem('token');
  };

  const getUserEmail = (): string | null => {
    return localStorage.getItem('email');
  };

  return {
    login,
    logout,
    isAuthenticated,
    getUserEmail,
    loading,
    error
  };
};
